exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._9WNFaCXF3MOPnhx5jLAb4 {\n  font-size: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);
// Exports
exports.locals = {
	"compactText": "_9WNFaCXF3MOPnhx5jLAb4"
};